import React from 'react';
import Link from "next/link";
import {getAreaUrl} from "@models/area";
import Icon from "@atoms/icon";
import ChevronLeftIcon from "@icons/chevron-left.svg";

const SiteMapAreas = ({city, regions, areas}) => {

    return (
        <div className="">
            <h2>محله‌های {city.name}</h2>

            <div className="row">

                {
                    (regions && regions.length) ?
                        regions.map((region, key) =>
                            <div className="col-12 col-md-6 col-lg-3" key={region.id}>
                                <a href={getAreaUrl(region)} className="mt-24 d-flex align-items-center items-link" title={region.district_name + ' ' + region.city_name}>
                                    <span className="text-ellipsis">{region.district_name} {region.city_name}</span>
                                    <Icon width={5} className="mr-8">
                                        <ChevronLeftIcon/>
                                    </Icon>
                                </a>
                            </div>
                        )
                        : ''
                }

                {
                    (areas && areas.length) ?
                        areas.map((area, key) =>
                            <div className="col-12 col-md-6 col-lg-3" key={area.id}>
                                <Link href="/pages/areas/show" as={getAreaUrl(area)}>
                                    <a className="mt-24 d-flex align-items-center items-link" title={area.district_name}>
                                        <span className="text-ellipsis">{area.district_name}</span>
                                        <Icon width={5} className="mr-8">
                                            <ChevronLeftIcon/>
                                        </Icon>
                                    </a>
                                </Link>
                            </div>
                        )
                        : ''
                }

            </div>
        </div>
    );
};

export default React.memo(SiteMapAreas);
